const USER_AUTHENTICATE = "USER_AUTHENTICATE";
const USER_REGISTER = "USER_REGISTER";
const USER_LOGOUT = "USER_LOGOUT";
const ADMIN_LOGIN = "ADMIN_LOGIN";
const UPDATE_VENDOR_DETAILS = 'UPDATE_VENDOR_DETAILS'

const authConstant = {
	USER_AUTHENTICATE,
	USER_REGISTER,
	USER_LOGOUT,
	ADMIN_LOGIN,
	UPDATE_VENDOR_DETAILS
};

export default authConstant;
